import { z } from "zod";

const socialMediaIconEnum = z.enum([
  "FACEBOOK",
  "INSTAGRAM",
  "LINE",
  "MAIL",
  "SNAPCHAT",
  "TELEGRAM",
  "VIBER",
  "WHATS_UP",
  "X",
  "YOUTUBE",
]);

const socialMediaItemSchema = z.object({
  icon: socialMediaIconEnum,
  uri: z.string().url(),
});

const additionalInfoSchema = z.object({
  title: z.string(),
  message: z.string(),
});

const orderSummarySharedFields = {
  displayItemsSummary: z.boolean().optional(),
  displayShippingAddress: z.boolean().optional(),
  displayDeliveryMethod: z.boolean().optional(),
  displayBillingAddress: z.boolean().optional(),
  displayPaymentMethod: z.boolean().optional(),
  displayLoyaltyConfirmation: z.boolean().optional(),
  withdrawOrderInfo: z.string().optional(),
};

const orderSummaryMinimalConfiguration = z.object({
  ...orderSummarySharedFields,
  displaySocialMedia: z.literal(false),
  displayAdditionalInfo: z.literal(false),
  socialMediaTitle: z.string().optional(),
  socialMedia: z.array(socialMediaItemSchema).optional(),
  additionalInfo: additionalInfoSchema.optional(),
});

const orderSummaryWithSocialMedia = z.object({
  ...orderSummarySharedFields,
  displaySocialMedia: z.literal(true),
  socialMediaTitle: z.string(),
  socialMedia: z.array(socialMediaItemSchema).nonempty(),
  displayAdditionalInfo: z.literal(false),
  additionalInfo: additionalInfoSchema.optional(),
});

const orderSummaryWithAdditionalInfo = z.object({
  ...orderSummarySharedFields,
  displaySocialMedia: z.literal(false),
  socialMediaTitle: z.string().optional(),
  socialMedia: z.array(socialMediaItemSchema).optional(),
  displayAdditionalInfo: z.literal(true),
  additionalInfo: additionalInfoSchema,
});

const orderSummaryFullConfiguration = z.object({
  ...orderSummarySharedFields,
  displaySocialMedia: z.literal(true),
  socialMediaTitle: z.string(),
  socialMedia: z.array(socialMediaItemSchema).nonempty(),
  displayAdditionalInfo: z.literal(true),
  additionalInfo: additionalInfoSchema,
});

export const orderSummaryConfigSchema = z.union([
  orderSummaryMinimalConfiguration,
  orderSummaryWithSocialMedia,
  orderSummaryWithAdditionalInfo,
  orderSummaryFullConfiguration,
]);
